import { useContext } from "react";
import { Outlet } from "react-router-dom";
import userContext from "src/context/userContext";
import DashboardLayout from "src/Layout/DashboardLayout";

export default function ProtectedView() {
    const { user } = useContext(userContext)
    return (
        user
            ?
            <DashboardLayout>
                <Outlet />
            </DashboardLayout>
            :
            <></>
    )

}